import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ToastType } from '../../types/toast-type.type';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.component.html'
})
export class ToastComponent implements OnInit,OnDestroy{
  @Input() type: ToastType = 'default'; 
  @Input() message: string = '';         
  @Input() icon: string = ''; 
  @Input() isVisible: boolean = true;      
  @Output() toastClose = new EventEmitter<void>();

  
  private timerId: any;

  constructor() {}

  ngOnInit(): void {
      this.timerId = setTimeout(() => {
      this.closeToast();
    }, 4000);
  }

  closeToast() {
    this.isVisible = false;  
    this.toastClose.emit(); 
  }
  ngOnDestroy(): void {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }

  }

  getToastColor() {
    const colors = {
      success: 'bg-[#E1FCDE] ',
      error: 'bg-[#FFD4D8] ',
      warning: 'bg-[#FFF2D2] ',
      info: 'bg-[#E0EDFF]',
      default: 'bg-[#F6F8FB]',
    };
    return colors[this.type] || colors['default'];
  }

}
